import oldThumbnailUploadTpl from '../templates/ad_builder/thumbnail_upload.html';

export default function oldThumbnailUpload() {
  return {
    restrict: 'E',
    template: oldThumbnailUploadTpl,
    scope: {
      thumbnailUrl: '=',
      hasError: '=',
      screenSize: '='
    }
  };
}
